
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mock-interview",
      function () {
        return require("private-next-pages/mock-interview.tsx");
      }
    ]);
  